/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Radio } from "antd";
import { useEffect, useState } from "react";
interface Props {
  data: any;
  viewOnly?: boolean;
}

export default function DetailsTemplateMultipleChoGrid({
  data,
  viewOnly,
}: Props) {
  const [selections, setSelections] = useState<Record<number, any>>({});

  const rows: string[] = data?.grid_rows || [];
  const columns: string[] = data?.grid_columns || [];

  const handleChange = (rowIndex: any, value: any) => {
    if (viewOnly) {
      if (answers && rows.length > 0) {
        const defaultSelections: Record<number, string> = {};

        rows.forEach((rowLabel, index) => {
          if (answers[rowLabel]) {
            defaultSelections[index] = answers[rowLabel];
          }
        });

        setSelections(defaultSelections);
        return;
      }
      return;
    }
    setSelections((prev) => ({ ...prev, [rowIndex]: value }));
  };
  const answers: Record<string, string> = data?.answer || {};
  // Set default answers from "answer"
  useEffect(() => {
    if (answers && rows.length > 0) {
      const defaultSelections: Record<number, string> = {};

      rows.forEach((rowLabel, index) => {
        if (answers[rowLabel]) {
          defaultSelections[index] = answers[rowLabel];
        }
      });

      setSelections(defaultSelections);
    }
  }, [data]);
  return (
    <>
      <Card className="mt-4">
        <div className="self-stretch justify-start text-zinc-700 text-base font-medium">
          Multiple Choice Grid - {data?.question_title}
        </div>

        <div className="overflow-x-auto mt-6">
          <table className="min-w-full table-fixed border-separate border-spacing-y-2">
            <thead>
              <tr>
                <th className="w-1/3 text-left"></th>
                {columns.map((col, index) => (
                  <th
                    key={index}
                    className="text-center  justify-start text-slate-700 text-base font-medium"
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((rowLabel, rowIndex) => (
                <tr key={rowIndex} className="bg-slate-100 rounded-lg">
                  <td className="py-3 px-4 text-sm text-gray-700">
                    {rowLabel}
                  </td>
                  {columns.map((colLabel, colIndex) => (
                    <td key={colIndex} className="text-center">
                      <Radio.Group
                        onChange={(e) => handleChange(rowIndex, e.target.value)}
                        value={selections[rowIndex]}
                      >
                        <Radio value={colLabel} />
                      </Radio.Group>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </>
  );
}
